import { render, staticRenderFns } from "./lightDetail.vue?vue&type=template&id=131eedcf&scoped=true&"
import script from "./lightDetail.vue?vue&type=script&lang=js&"
export * from "./lightDetail.vue?vue&type=script&lang=js&"
import style0 from "./lightDetail.vue?vue&type=style&index=0&id=131eedcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131eedcf",
  null
  
)

export default component.exports